import React from 'react';
import { HallowComponent } from "../HallowComponent";

class Timebar extends HallowComponent {
    // required props: markerLeft (starting position for the marker)
    _timebar; // the overall containing element for this timebar
    timeoutId = null; // the timeoutId used for click-and-hold events
    newMarkerState = this.props.markerLeft; // this feels like an anti-pattern in React, but it makes everything work properly
    state = {
        markerNow: '' + this.props.markerLeft, // this should be a string so it resembles a percentage and can be parsed
        fullTime: this.makeTimeString(this.props.duration),
        nowTime: this.makeTimeString(this.props.getMs(this.props.markerLeft)),
    };

    //#region Static Functions
    makeTimeString(ms) {
        let s = Math.floor(ms / 1000);
        let min = Math.floor(s / 60);
        s -= (min * 60);
        return min + ':' + ('' + s).padStart(2, '0');
    }

    getMarkerPosition(clientX, rect) {
        if (clientX <= rect.left) {
            return '0';
        }
        if (clientX >= rect.right) {
            return '100%';
        }
        return (clientX - rect.left) / rect.width * 100 + '%';
    }
    //#endregion

    //#region Event Handlers
    handleDrag = (ev) => {
        if (ev) ev.preventDefault();
        document.body.classList.add('grabbed');
        document.onmousemove = this.handleMove;
        document.onmouseup = this.handleDrop;
        this.props.onPickUp();
        this.timeoutId = null;
    }

    handleMove = (ev) => {
        ev.preventDefault();
        this.newMarkerState = this.getMarkerPosition(ev.clientX, this._timebar.getBoundingClientRect());
        let newTime = this.props.getMs(this.newMarkerState);
        this.setState({ markerNow: this.newMarkerState, nowTime: this.makeTimeString(newTime) });
    }

    handleDrop = (ev) => {
        ev.preventDefault();
        document.body.classList.remove('grabbed');
        document.onmousemove = null;
        document.onmouseup = null;
        this.props.onChange(this.newMarkerState);
    }

    handleJump = (ev) => {
        ev.preventDefault();
        this.props.onPickUp();
        this.handleMove(ev);
        this.timeoutId = setTimeout(this.handleDrag, 100);
    }

    clearHold = () => {
        clearTimeout(this.timeoutId);
        if (this.timeoutId !== null) {
            this.props.onChange(this.newMarkerState, this.pausedForJump);
            this.pausedForJump = false;
        }
    }
    //#endregion

    moveMarker = (percent, newTime) => {
        this.setState({ markerNow: percent, nowTime: this.makeTimeString(newTime) });
    }

    render() {
        return (<div id={this.props.id} className='timeBar' ref={ c => this._timebar = c } onMouseUp={this.clearHold} key={this.generateChildKey('scrubber')}>
            <div className='clickZone' onMouseDown={this.handleJump} key={this.generateChildKey('clickZone')} />
            <div id={this.props.id + '_marker'} className='timeMarker' style={ { left: this.state.markerNow } } key={this.generateChildKey('timeMarker')}>
                <div className='timeGrabbable' onMouseDown={this.handleDrag} key={this.generateChildKey('timeGrabbable')} />
            </div>
            <div className='nowTime' key={this.generateChildKey('nowTime')}>{this.state.nowTime}</div>
            <div className='fullTime' key={this.generateChildKey('fullTime')}>{this.state.fullTime}</div>
        </div>);
    }
}

export default Timebar;